import { invertLuminance } from '../util';
import { graphDataStyle, graphDefault, graphWallFill } from './';
export const graphSelection = (theme, parameters) => {
  const color = graphWallFill(theme, parameters).fillColor;
  const altColor = invertLuminance(color);
  const styleDefault = graphDataStyle.styleDefault(theme, parameters);
  const common = {
    color,
    fillColor: color,
    markerSize: styleDefault.markerSize,
    markerSymbol: styleDefault.markerSymbol,
    lineStyle: 'solid'
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        const white = graphDefault(theme, parameters).white;
        return {
          ...common,
          altColor: white,
          markerColor: white,
          lineColor: white,
          textColor: white,
          lineThickness: 2
        };
      }
    case 'high-contrast':
      {
        return {
          ...common,
          altColor,
          markerColor: altColor,
          lineColor: altColor,
          textColor: altColor,
          lineThickness: 5
        };
      }
    default:
      {
        return {
          ...common,
          altColor,
          markerColor: altColor,
          lineColor: altColor,
          textColor: altColor,
          lineThickness: 2
        };
      }
  }
};
//# sourceMappingURL=graphSelection.js.map